import {getServiceCategories, searchServiceCategory} from '@/services/endpoints/serviceCategories'
import { getServiceProperties, searchServiceProperties} from '@/services/endpoints/serviceProperties'
import {addService, getServices, updateService, searchService, findAService,deleteService,getOneService,getLabService} from '@/services/endpoints/service'
import statuses from "@/constatnts/statuses";
import {searchRadiologyTest} from "@/services/endpoints/radiologyTest";
import {addReceptionServices} from "@/services/endpoints/receptionServices";
import {patientPayment} from "@/services/endpoints/accountingArticles";
import localForage from "localforage";
import {searchContraceptive} from "@/services/endpoints/contraceptive";

export default {
    async getServices({commit}, payload) {
        // return new Promise((resolve, reject) => {
        try {
            let res = await getServices(payload);
            if(res) {
                res.data.data.forEach((s,index) => {
                    s.id = index
                });
                commit('SET_SERVICES', {services :res.data.data})
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },

    async deleteService({ commit }, payload) {
        try {
            let res = await deleteService(payload.servicesId)
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async updateService({commit},payload) {
        try {
            let res = await updateService(payload.id, payload.payload);
            if(res) {
                // commit('SET_SERVICES', res.data)
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getServiceCategories({commit}) {
        // return new Promise((resolve, reject) => {
        try {
            let res = await getServiceCategories();
            if(res) {
                commit('SET_CATEGORIES', res.data)
                return res.data
            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async getServiceProperties({ commit }) {
        try {
            let res = await getServiceProperties();
            if(res) {
                commit('SET_PROPERTIES', res.data)
                return res.data
            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async getActiveServiceProperties({ commit }) {
        try {
            let res = await searchServiceProperties({status: statuses.ACTIVE});
            if(res) {
                commit('SET_PROPERTIES', res.data.data)
                return res.data.data
            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async addService({ commit }, payload) {
        try {
            let res = await addService(payload);
            if(res) {
                // commit('SET_PROPERTIES', res.data.data)
                return res.data
            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async searchService({ commit }, payload) {
        try {

            let res = await searchService(payload);

            if(res) {
                res.data.data.forEach((s,index) => {
                    s.id = index
                });
                 commit('SET_SERVICES', {items: res.data.data})

                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    // async searchActiveService({ commit }, version = false) {
    //     try {
    //         let currentVersion = await localForage.getItem('services-version');
    //         if(version && currentVersion) {
    //             if(version !== currentVersion) {
    //                 let res = await searchService({status: statuses.ACTIVE});
    //                 if(res) {
    //                     commit('SET_SERVICES', res.data.data)
    //                     commit('SET_SERVICES', {version: version, labService: res.data.data})
    //                     return res.data.data
    //                 }
    //             }
    //             else{
    //                 const items = await localForage.getItem('labService');
    //                 if(!items){
    //                     let res = await searchService({serviceCategoryType : 'lab',status: statuses.ACTIVE});
    //                     if(res) {
    //                         commit('SET_SERVICES', {version: version, labService: res.data.data})
    //                         return res.data.data
    //                     }
    //                 }
    //                 else commit('SET_SERVICES',{status : 'fetched',items: items});
    //                 return items;
    //             }
    //         }
    //         else{
    //             let res = await searchService({serviceCategoryType : 'lab',status: statuses.ACTIVE});
    //             if (res) {
    //                 commit('SET_SERVICES', {version: version, labService: res.data.data});
    //                 return res.data.data
    //             }
    //         }
    //
    //     }
    //     catch (err) {
    //         
    //         throw new Error(err)
    //     }
    //     try {
    //
    //         let res = await searchService(payload);
    //
    //         if(res) {
    //             res.data.data.forEach((s,index) => {
    //                 s.id = index
    //             });
    //              commit('SET_SERVICES', res.data.data)
    //             commit('SET_TOTAL', res.data.total)
    //             return res.data.data
    //         }
    //     }
    //     catch (err) {
    //         
    //         throw new Error(err)
    //     }
    // },
    async findServicesDiscounts({ commit }, services) {
        try {
            let promises = [];
            services.forEach((service) => {
                promises.push(findAService(service.serviceId));
            });
            let res = await Promise.all(promises).then((value) => {
                value = value.map((v)=>{
                    return v.data.getDiscountGroups
                })
                return value;
                // // console.log(value);
            });
            // let res = await patientPayment(payment);
            if (res.length == services.length) {
                return res;
            }
        } catch (err) {
            
            throw new Error("submitted numbers :", res.length);
        }
        // try {
        //     let promises = [];
        //     services.forEach(async (service) =>{
        //         promises.push(findAService(service.serviceId));
        //         let res = await Promise.all(promises).then((value) => {
        //             // console.log(value, value.length == payload.length);
        //             return value;
        //         });
        //     })
        //     let res = await searchService(payload);
        //
        //     if(res) {
        //         res.data.data.forEach((s,index) => {
        //             s.id = index
        //         });
        //          commit('SET_SERVICES', res.data.data)
        //         commit('SET_TOTAL', res.data.total)
        //         return res.data.data
        //     }
        // }
        // catch (err) {
        //     
        //     throw new Error(err)
        // }
    },
    async searchServiceCategory({ commit }, payload) {
        try {

            let res = await searchServiceCategory(payload);

            if(res) {
                // res.data.data.forEach((s,index) => {
                //     s.id = index
                // });
                 commit('SET_CATEGORIES', res.data.data)
                // commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async searchActiveServiceCategory({ commit }) {
        try {

            let res = await searchServiceCategory({status: 'active'});

            if(res) {
                // res.data.data.forEach((s,index) => {
                //     s.id = index
                // });
                 commit('SET_CATEGORIES', res.data.data)
                // commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async findAService({ commit }, serviceId) {
        try {
            let res = await findAService(serviceId);
            if(res) {
                return res.data
            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async getLabService({ commit },version = false) {
        try {
            let currentVersion = await localForage.getItem('services-version');
            if(version && currentVersion) {
                if(version !== currentVersion) {
                    let res = await searchService({serviceCategoryType : 'lab',status: statuses.ACTIVE});
                    if(res) {
                        commit('SET_LAB_SERVICES', {version: version, labServices: res.data.data})
                        return res.data.data
                    }
                }
                else{
                    const items = await localForage.getItem('labServices');
                    if(!items){
                        let res = await searchService({serviceCategoryType : 'lab',status: statuses.ACTIVE});
                        if(res) {
                            commit('SET_LAB_SERVICES', {version: version, labServices: res.data.data})
                            return res.data.data
                        }
                    }
                    else commit('SET_LAB_SERVICES',{status : 'fetched',items: items});
                    return items;
                }
            }
            else{
                let res = await searchService({serviceCategoryType : 'lab',status: statuses.ACTIVE});
                if (res) {
                    commit('SET_LAB_SERVICES', {version: version, labServices: res.data.data});
                    return res.data.data
                }
            }

        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async getLabServiceCategories({ commit },version = false) {
        try {
            let currentVersion = await localForage.getItem('services-version');
            if(version && currentVersion) {
                if(version !== currentVersion) {
                    let res = await getLabService({serviceCategoryType : 'lab',status: statuses.ACTIVE});
                    if(res) {
                        commit('SET_SERVICES_CATEGORIES', {version: version, serviceCategories: res.data})
                        return res.data
                    }
                }
                else{
                    const items = await localForage.getItem('serviceCategories');
                    if(!items){
                        let res = await getLabService({serviceCategoryType : 'lab',status: statuses.ACTIVE});
                        if(res) {
                            commit('SET_SERVICES_CATEGORIES', {version: version, serviceCategories: res.data})
                            return res.data
                        }
                    }
                    else commit('SET_SERVICES_CATEGORIES',{status : 'fetched',items: items});
                    return items;
                }
            }
            else{
                let res = await getLabService({serviceCategoryType : 'lab',status: statuses.ACTIVE});
                if (res) {
                    commit('SET_SERVICES_CATEGORIES', {version: version, serviceCategories: res.data});
                    return res.data
                }
            }

        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async getMriServices({ commit },version = false) {
        try {
            let currentVersion = await localForage.getItem('services-version');
            if(version && currentVersion) {
                if(version !== currentVersion) {
                    let res = await searchService({serviceCategoryType: 'radiology',serviceCategorySubType: 'radiology_mri',status: statuses.ACTIVE});
                    if(res) {
                        commit('SET_MRI_SERVICES', {version: version, mriServices: res.data.data})
                        return res.data.data
                    }
                }
                else{
                    const items = await localForage.getItem('mriServices');
                    if(!items){
                    let res = await searchService({serviceCategoryType: 'radiology',serviceCategorySubType: 'radiology_mri',status: statuses.ACTIVE});
                        if(res) {
                            commit('SET_MRI_SERVICES', {version: version, mriServices: res.data.data})
                            return res.data.data
                        }
                    }
                    else commit('SET_MRI_SERVICES',{status : 'fetched',items: items});
                    return items;
                }
            }
            else{
                    let res = await searchService({serviceCategoryType: 'radiology',serviceCategorySubType: 'radiology_mri',status: statuses.ACTIVE});
                if (res) {
                    commit('SET_MRI_SERVICES', {version: version, mriServices: res.data.data});
                    return res.data.data
                }
            }

        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getCtScanServices({ commit }, version = false) {
        try {
            let currentVersion = await localForage.getItem('services-version');
            if(version && currentVersion) {
                if(version !== currentVersion) {
                    let res = await searchService({serviceCategoryType: 'radiology',serviceCategorySubType: 'radiology_ct_scan',status: statuses.ACTIVE});
                    if(res) {
                        commit('SET_CT_SCAN_SERVICES', {version: version, ctScanServices: res.data.data})
                        return res.data.data
                    }
                }
                else{
                    const items = await localForage.getItem('ctScanServices');
                    if(!items){
                        let res = await searchService({serviceCategoryType: 'radiology',serviceCategorySubType: 'radiology_ct_scan',status: statuses.ACTIVE});
                        if(res) {

                            commit('SET_CT_SCAN_SERVICES', {version: version, ctScanServices: res.data.data})
                            return res.data.data
                        }
                    }
                    else {

                        commit('SET_CT_SCAN_SERVICES',{status : 'fetched',items: items});
                    }
                    return items;
                }
            }
            else{
                let res = await searchService({serviceCategoryType: 'radiology',serviceCategorySubType: 'radiology_ct_scan',status: statuses.ACTIVE});
                if (res) {

                    commit('SET_CT_SCAN_SERVICES', {version: version, ctScanServices: res.data.data});
                    return res.data.data
                }
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getFemaleSonographiesService({ commit },version = false) {
        try {
            let currentVersion = await localForage.getItem('services-version');
            if(version && currentVersion) {
                if(version !== currentVersion) {

                    let res = await searchService({serviceCategoryType : 'sonography',status: statuses.ACTIVE,serviceGender:'female'});
                    if(res) {
                        commit('SET_FEMALE_SONOGRAPHIES_SERVICES', {version: version, femaleSonographiesService: res.data.data})
                        return res.data.data
                    }
                }
                else{
                    const items = await localForage.getItem('femaleSonographiesService');
                    if(!items){
                        let res = await searchService({serviceCategoryType : 'sonography',status: statuses.ACTIVE,serviceGender:'female'});
                        if(res) {
                            commit('SET_FEMALE_SONOGRAPHIES_SERVICES', {version: version, femaleSonographiesService: res.data.data})
                            return res.data.data
                        }
                    }
                    else commit('SET_FEMALE_SONOGRAPHIES_SERVICES',{status : 'fetched',items: items});
                    return items;
                }
            }
            else{
                let res = await searchService({serviceCategoryType : 'sonography',status: statuses.ACTIVE,serviceGender:'female'});
                if (res) {
                    commit('SET_FEMALE_SONOGRAPHIES_SERVICES', {version: version, femaleSonographiesService: res.data.data});
                    return res.data.data
                }
            }

        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async getMaleSonographiesService({ commit },version = false) {
        try {
            let currentVersion = await localForage.getItem('services-version');
            if(version && currentVersion) {
                if(version !== currentVersion) {

                    let res = await searchService({serviceCategoryType : 'sonography',status: statuses.ACTIVE,serviceGender:'male'});
                    if(res) {
                        commit('SET_MALE_SONOGRAPHIES_SERVICES', {version: version, maleSonographiesService: res.data.data})
                        return res.data.data
                    }
                }
                else{
                    const items = await localForage.getItem('maleSonographiesService');
                    if(!items){
                        let res = await searchService({serviceCategoryType : 'sonography',status: statuses.ACTIVE,serviceGender:'male'});
                        if(res) {
                            commit('SET_MALE_SONOGRAPHIES_SERVICES', {version: version, maleSonographiesService: res.data.data})
                            return res.data.data
                        }
                    }
                    else commit('SET_MALE_SONOGRAPHIES_SERVICES',{status : 'fetched',items: items});
                    return items;
                }
            }
            else{
                let res = await searchService({serviceCategoryType : 'sonography',status: statuses.ACTIVE,serviceGender:'male'});
                if (res) {
                    commit('SET_MALE_SONOGRAPHIES_SERVICES', {version: version, maleSonographiesService: res.data.data});
                    return res.data.data
                }
            }

        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async getFemaleSurgeriesService({ commit },version = false) {
        try {
            let currentVersion = await localForage.getItem('services-version');
            if(version && currentVersion) {
                if(version !== currentVersion) {

                    let res = await searchService({serviceCategoryType : 'surgery',status: statuses.ACTIVE,serviceGender:'female'});
                    if(res) {
                        commit('SET_FEMALE_SURGERIES_SERVICES', {version: version, femaleSurgeriesService: res.data.data})
                        return res.data.data
                    }
                }
                else{
                    const items = await localForage.getItem('femaleSurgeriesService');
                    if(!items){
                        let res = await searchService({serviceCategoryType : 'surgery',status: statuses.ACTIVE,serviceGender:'female'});
                        if(res) {
                            commit('SET_FEMALE_SURGERIES_SERVICES', {version: version, femaleSurgeriesService: res.data.data})
                            return res.data.data
                        }
                    }
                    else commit('SET_FEMALE_SURGERIES_SERVICES',{status : 'fetched',items: items});
                    return items;
                }
            }
            else{
                let res = await searchService({serviceCategoryType : 'surgery',status: statuses.ACTIVE,serviceGender:'female'});
                if (res) {
                    commit('SET_FEMALE_SURGERIES_SERVICES', {version: version, femaleSurgeriesService: res.data.data});
                    return res.data.data
                }
            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async getMaleSurgeriesService({ commit },version = false) {
        try {
            let currentVersion = await localForage.getItem('services-version');
            if(version && currentVersion) {
                if(version !== currentVersion) {

                    let res = await searchService({serviceCategoryType : 'surgery',status: statuses.ACTIVE,serviceGender:'male'});
                    if(res) {
                        commit('SET_MALE_SURGERIES_SERVICES', {version: version, maleSurgeriesService: res.data.data})
                        return res.data.data
                    }
                }
                else{
                    const items = await localForage.getItem('maleSurgeriesService');
                    if(!items){
                        let res = await searchService({serviceCategoryType : 'surgery',status: statuses.ACTIVE,serviceGender:'male'});
                        if(res) {
                            commit('SET_MALE_SURGERIES_SERVICES', {version: version, maleSurgeriesService: res.data.data})
                            return res.data.data
                        }
                    }
                    else commit('SET_MALE_SURGERIES_SERVICES',{status : 'fetched',items: items});
                    return items;
                }
            }
            else{
                let res = await searchService({serviceCategoryType : 'surgery',status: statuses.ACTIVE,serviceGender:'male'});
                if (res) {
                    commit('SET_MALE_SURGERIES_SERVICES', {version: version, maleSurgeriesService: res.data.data});
                    return res.data.data
                }
            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async getServiceToEdit({ commit }, serviceId) {
        try {
            let res = await getOneService(serviceId);
            if (res) {
                commit("SET_SERVICE_TO_EDIT", res.data[0]);
                return res.data;
            }
        } catch (err) {
            
            throw new Error(err);
        }
    },
}
